export default __webpack_public_path__ + "static/media/chimes.dd91cbaf.wav";